import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Box,
  TextField,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,

} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { GeneralInfoField, StatusCommissionField, AddressField, ContactField, SalesPersonStatus, SalesPersonAppliedTo } from './salesPersonFormDataConfig';

import API_BASE_URL from '../../../../Constants';


const AddSalesPersonModal = ({ open, handleClose }) => {

  const [salesPerson, setSalesPerson] = useState({
    status: 1,
    appliedTo: 1
  });
  const [isEditMode, setIsEditMode] = useState(true);
  const [isFullView, setIsFullView] = useState(false);



  const toggleFullView = () => {
    setIsFullView((prev) => !prev);
  };

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const handleClear = () => {
    setSalesPerson({
      status: 1,
      appliedTo: 1
    });
  };

  const handleSubmit = () => {
    try {
      fetch(`${API_BASE_URL}/api/setup/salesperson/createSalesPerson`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(salesPerson),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Success:', data);
          handleClear();
          handleClose();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    catch (error) {
      console.error('Error:', error);
    }
  }






  const renderFields = (fields, formData, editable = false) => {
    return fields.map((field) => {
      if (field.key === 'id') return null;
      return (
        <div key={field.key} className="flex items-center py-0.5">
          <h3
            className="flex min-w-[calc(40%-2rem)] my-auto px-2 text-right font-semibold text-lg text-gray-600"
            style={{
              position: 'relative',
              borderBottom: '4px dotted #ccc',  // Changed to dotted border
              paddingBottom: '10px',            // Adds space between text and border
              marginRight: '16px'               // Adds space between label and input
            }}
          >
            {field.label}
          </h3>
          <div className="w-full">
            {editable ?


              (
                (field.key !== 'status' && field.key !== 'appliedTo' && field.key !== 'percent') ?
                  <TextField
                    fullWidth
                    variant="outlined"
                    required={!(field.key in ["phone2", "phone3", "fax"])}
                    name={field.key}
                    value={formData[field.key] || ''}
                    onChange={(e) =>
                      setSalesPerson({ ...salesPerson, [field.key]: e.target.value })
                    }
                    InputProps={{
                      style: {
                        backgroundColor: 'white',
                      },
                    }}
                  />
                  :
                  // select options 
                  (

                    <>

                      {field.key === 'status' && (
                        // select options dropdown
                        <select
                          className="border border-gray-300 p-2 mr-2 rounded-md"
                          value={formData[field.key]}
                          required={true}
                          onChange={(e) => {

                            setSalesPerson({ ...salesPerson, [field.key]: Number(e.target.value) });
                          }}
                        >
                          {
                            SalesPersonStatus.map((status) => (
                              <option key={status.value} value={status.value}>
                                {status.label}
                              </option>
                            )
                            )
                          }
                        </select>



                      )

                      }

                      {field.key === 'appliedTo' && (

                        <select
                          className="border border-gray-300 p-2 mr-2 rounded-md"
                          value={formData[field.key]}
                          required={true}
                          onChange={(e) => {

                            setSalesPerson({ ...salesPerson, [field.key]: Number(e.target.value) });
                          }}
                        >
                          {
                            SalesPersonAppliedTo.map((applied) => (
                              <option key={applied.value} value={applied.value}>
                                {applied.label}
                              </option>
                            )
                            )
                          }
                        </select>
                      )

                      }


                      {field.key === 'percent' && (

                        // number input 0 to 100 with decimal
                        <input
                          type="number"
                          min="0"
                          max="100"
                          step="0.01"
                          className="border border-gray-300 p-2 mr-2 rounded-md"
                          required={true}
                          value={formData[field.key]}
                          onChange={(e) => {

                            setSalesPerson({ ...salesPerson, [field.key]: Number(e.target.value) % 101 });
                          }}
                        />)}
                    </>

                  )
              ) : (
                <Box
                  sx={{
                    padding: '6px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                  }}
                >
                  {formData[field.key] !== undefined && formData[field.key] !== null
                    ? formData[field.key]
                    : 'N/A'}
                </Box>
              )}
          </div>
        </div>
      )
    });
  };

  return (
    <>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth={true}
        fullScreen={isFullView}
        PaperProps={{
          sx: {
            backgroundColor: 'white',
            boxShadow: 'none',
            margin: isFullView ? 2 : 'auto',
            width: isFullView ? 'calc(100% - 32px)' : '80%',
            height: isFullView ? 'calc(100% - 32px)' : '80%',
          },
        }}
      >
        <DialogContent


          dividers
          sx={{
            padding: 0,
            maxHeight: '90vh',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >

          {/* Sticky Top Section */}
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              backgroundColor: '#f0f4f8',
              zIndex: 2,
              borderBottom: '1px solid #ccc',
              borderTop: '1px solid #ccc',
            }}
          >
            {/* First Row: Back Button and Maximize Button */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              paddingY={1}
              paddingX={2}
              sx={{
                backgroundColor: '#e0e0e0',
                borderBottom: '1px solid #ccc',
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #ccc',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  },
                }}
                aria-label="Close Modal"
              >
                <ArrowBackIcon />
              </IconButton>
              <IconButton
                onClick={toggleFullView}
                sx={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #ccc',
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  },
                }}
                aria-label="Toggle Fullscreen"
              >
                {isFullView ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Box>

            {/* Second Row: Title */}
            <Box
              paddingX={2}
              paddingY={1}
              sx={{
                backgroundColor: '#fafafa',
                borderBottom: '1px solid #ccc',
              }}
            >
              <Typography
                variant="h3"
                component="div"
                className="font-bold"
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem' },
                  color: '#333',
                }}
              >
                {

                  'Sales Person Details'}
              </Typography>
            </Box>
            {/* Third Row: Action Buttons */}
            <Box
              display="flex"
              alignItems="center"
              paddingX={2}
              paddingBottom={2}
              paddingTop={2}
            >
              {/* Action Buttons */}
              <Box>
                <Button
                  onClick={handleClear}
                  style={{
                    backgroundColor: '#E53E3E',
                    color: 'white',
                    marginRight: '0.5rem',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s',
                  }}
                  startIcon={<DeleteIcon />}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#C53030';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#E53E3E';
                  }}
                >
                  Clear
                </Button>


                {isEditMode ? (


                  <Button
                    onClick={toggleEditMode}
                    style={{
                      backgroundColor: '#A0AEC0',
                      color: 'black',
                      textTransform: 'none',
                      fontWeight: 'bold',
                      transition: 'background-color 0.3s',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#718096';
                      e.currentTarget.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#A0AEC0';
                      e.currentTarget.style.color = 'black';
                    }}
                  >
                    View
                  </Button>

                ) : (
                  <>

                    <Button
                      onClick={toggleEditMode}
                      style={{
                        backgroundColor: '#ECC94B',
                        color: 'white',
                        textTransform: 'none',
                        fontWeight: 'bold',
                        transition: 'background-color 0.3s', marginRight: '0.5rem',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#D69E2E';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ECC94B';
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      type='submit'
                      onClick={handleSubmit}
                      style={{
                        backgroundColor: '#4299E1',
                        color: 'white',

                        textTransform: 'none',
                        fontWeight: 'bold',
                        transition: 'background-color 0.3s',
                      }}
                      startIcon={<AddIcon />}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#2B6CB0';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#4299E1';
                      }}
                    >
                      Add
                    </Button>
                  </>
                )}
              </Box>
            </Box>
          </Box>

          {/* Scrollable Content */}
          <Box sx={{ padding: 2 }}>

            <div className="space-y-5 p-2 rounded-2xl">
              {/* General Information Section */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="general-info-content"
                  id="general-info-header"
                  sx={{ padding: '0 16px' }}
                >
                  <Typography
                    variant="h5"
                    className="font-bold"
                    sx={{
                      paddingBottom: '4px',
                      width: '100%',
                      borderBottom: '1px solid #ccc',
                    }}
                  >
                    General Information
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '12px' }}>
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '1fr',
                      md: '1fr',
                      lg: 'repeat(2, 1fr)',
                    }}
                    gap={0.5}
                    className="p-1"
                  >
                    {renderFields(GeneralInfoField, salesPerson, isEditMode)}
                  </Box>
                </AccordionDetails>
              </Accordion>


              {/* Status/Commission Section */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="general-info-content"
                  id="general-info-header"
                  sx={{ padding: '0 16px' }}
                >
                  <Typography
                    variant="h5"
                    className="font-bold"
                    sx={{
                      paddingBottom: '4px',
                      width: '100%',
                      borderBottom: '1px solid #ccc',
                    }}
                  >
                    Status & Commission
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '12px' }}>
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '1fr',
                      md: '1fr',
                      lg: 'repeat(2, 1fr)',
                    }}
                    gap={0.5}
                    className="p-1"
                  >
                    {renderFields(StatusCommissionField, salesPerson, isEditMode)}
                  </Box>
                </AccordionDetails>
              </Accordion>

              {/* Address Section */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="general-info-content"
                  id="general-info-header"
                  sx={{ padding: '0 16px' }}
                >
                  <Typography
                    variant="h5"
                    className="font-bold"
                    sx={{
                      paddingBottom: '4px',
                      width: '100%',
                      borderBottom: '1px solid #ccc',
                    }}
                  >
                    Address
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '12px' }}>
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '1fr',
                      md: '1fr',
                      lg: 'repeat(2, 1fr)',
                    }}
                    gap={0.5}
                    className="p-1"
                  >
                    {renderFields(AddressField, salesPerson, isEditMode)}
                  </Box>
                </AccordionDetails>

              </Accordion>

              {/* Contact Section */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="general-info-content"
                  id="general-info-header"
                  sx={{ padding: '0 16px' }}
                >
                  <Typography
                    variant="h5"
                    className="font-bold"
                    sx={{
                      paddingBottom: '4px',
                      width: '100%',
                      borderBottom: '1px solid #ccc',
                    }}
                  >
                    Contact
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: '12px' }}>
                  <Box
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '1fr',
                      md: '1fr',
                      lg: 'repeat(2, 1fr)',
                    }}
                    gap={0.5}
                    className="p-1"
                  >
                    {renderFields(ContactField, salesPerson, isEditMode)}
                  </Box>
                </AccordionDetails>
              </Accordion>

            </div>

          </Box>

        </DialogContent>
      </Dialog>
    </>
  );
};

AddSalesPersonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddSalesPersonModal;
